import { BaseEntity } from "@bndes/bndes-ux4/bndes-angular-utils";
import { Tranche } from "./tranche.model";
import { LimiteAdicionalPorTrancheAgenteFinanceiro } from "./limite-adicional-por-tranch-agente-financeiro.model";
import { LimiteAdicionalProgramaBndesTranche } from "./limite-adicional-programa-bndes-tranche.model";

export class LimiteAdicionalTranch extends BaseEntity{

    tranche!:Tranche
    dataInicioProtocolo!:string
    dataFimProtocolo!:string;
    nome!:string;
    nomeUsuarioEnvio!: string;
    nomeUsuarioUltimaAtualizacao!: string;
    limitePorAgenteFinanceiro!:LimiteAdicionalPorTrancheAgenteFinanceiro[];
    limiteAdicionalProgramaBndesTranches!: LimiteAdicionalProgramaBndesTranche[];
    permiteRenunciaLimiteAdicional!: boolean;

}
